<template lang="pug">
  v-container.fill-height.align-center.justify-center.pa-0(max-width="600px" )
    v-card(flat width="800px" class="rounded-card mx-auto" d-flex justify-center)
      v-snackbar( v-model="snackBar" :color="snackbarColor" ) {{ snackBarMessage }}
        template( v-slot:action="{attrs}")
          v-btn(text v-bind="attrs" @click="snackBar = false")
            v-icon fas fa-times
      AddNewConfigurationDialog(
        v-if="showAddNewConfigurationDialog"
        :show="showAddNewConfigurationDialog"
        :configuration="configuration"
        :tagList="getFilteredTagList"
        :selectedConfiguration="selectedConfiguration"
        :keyList="keyList"
        :businesses="business"
        :loading="loading"
        :isLoading="isLoading"
        @close="onCloseDialogClick"
        @created="saveButtonClick"
        @updated="updatedDataClick"
        @delete="onDeleteConfigurationClick")
      v-row.ma-0(v-if="!fetchInProgress && configuration && this.$vuetify.breakpoint.mdAndUp")
        v-col(cols="12")
          v-card
            v-card-title.pb-0 {{ $t('settingsPage.configuration.globalConfigurationLabel') }}
            v-list
              //v-row.ma-0.ml-4
                v-checkbox(
                  on-icon="fas fa-check-square"
                  off-icon="far fa-square"
                  v-model="value1")
                span.pt-5 {{ $t('settingsPage.configuration.orderSingleGroup') }}
              v-row.ma-0.ml-4
                v-checkbox(
                  on-icon="fas fa-check-square"
                  off-icon="far fa-square"
                  v-model="reserveAll.value")
                span.pt-5 {{ $t('settingsPage.configuration.orderAutomatic') }}
            v-divider
            v-card-actions
              v-spacer
              v-btn(color="primary" @click="onSaveButtonClick" :loading="saveInProgress") {{ $t('settingsPage.offerStructure.slotEditorSaveButtonLabel') }}
        v-col.title.pl-8(cols="12") {{ $t('settingsPage.configuration.localConfigurationLabel') }}
        v-row.ma-0
          v-col.px-0(cols="12")
            v-toolbar.elevation-0
              v-btn(color="primary" medium @click="onAddNewConfigurationDialogClick" )
                v-icon fas fa-plus
                span.pl-2 {{ $t('settingsPage.configuration.addNewConfigurationGroup') }}


          v-col(cols="4" v-for="(i,idx) in configuration" :key="idx")
            v-card(v-if="configuration" max-width="500px" height="300px" )
              v-card-title.pa-0.pl-2
                v-row.ma-0
                v-col.pb-0(cols="6" v-if="configuration && i.title") {{'#' + (idx+1)}} {{i.title}}
                v-col.pb-0(cols="6" v-else) # {{idx}}

                v-col.text-end.pr-2.pb-0(cols="6")
                  v-btn.text-end( small fab color="primary" @click="showEditConfigurationDialog(i)" )
                    v-icon(small) fal fa-pen
              v-card-text.py-0.pb-0
                v-list.pt-0.pb-0
                  template()
                    v-row.justify-lg-space-around
                      v-col.pa-0(cols="12")
                        v-sheet
                          v-chip-group(show-arrows prev-icon="far fa-arrow-left" next-icon="far fa-arrow-right")
                            v-chip(v-for="(item, idx) in i.tags" :key="idx")
                              v-icon.mr-4e(left) {{item.iconClass}}
                              span {{item.title}}
                  v-list(dense)
                    v-row.ma-0
                      v-checkbox.ma-0(
                        v-model="i.settings['configuration_group.is_mandatory']"
                        on-icon="fas fa-check-square"
                        off-icon="far fa-square"
                        readonly)
                      span.pt-2 {{ $t('settingsPage.configuration.allowedLabel') }}
                    v-row.ma-0
                      v-checkbox.ma-0(
                        v-model="i.settings['configuration_group.single_item']"
                        on-icon="fas fa-check-square"
                        off-icon="far fa-square"
                        readonly)
                      span.pt-2 {{ $t('settingsPage.configuration.singleFoodLabel') }}
                    v-row.ma-0
                      v-checkbox.ma-0(
                        v-model="i.settings['configuration_group.show_price']"
                        on-icon="fas fa-check-square"
                        off-icon="far fa-square"
                        readonly)
                      span.pt-2 {{ $t('settingsPage.configuration.showPriceLabel') }}
      v-skeleton-loader(v-if="fetchInProgress" type="list-item-three-line@3" width="100%")
      v-row.ma-0(v-if="!fetchInProgress && configuration && this.$vuetify.breakpoint.smAndDown")
        v-col.pa-0.pr-6(cols="12")
          v-card()
            v-card-title.pb-0 {{ $t('settingsPage.configuration.globalConfigurationLabel') }}
            v-list
              //v-row.ma-0.ml-4
                v-checkbox(
                  on-icon="fas fa-check-square"
                  off-icon="far fa-square"
                  v-model="value1")
                span.pt-5 {{ $t('settingsPage.configuration.orderSingleGroup') }}
              v-row.ma-0.ml-4

                v-checkbox(
                  on-icon="fas fa-check-square"
                  off-icon="far fa-square"
                  v-model="reserveAll.value")
                span.pt-5 {{ $t('settingsPage.configuration.orderAutomatic') }}
            v-divider
            v-card-actions
              v-spacer
              v-btn(color="primary" @click="onSaveButtonClick" :loading="saveInProgress") {{ $t('settingsPage.offerStructure.slotEditorSaveButtonLabel') }}
        v-col.title(cols="12") {{ $t('settingsPage.configuration.localConfigurationLabel') }}
          v-row.ma-0
            v-col(cols="12")
              v-toolbar.elevation-0
                v-btn(color="primary" medium @click="onAddNewConfigurationDialogClick" )
                  v-icon fas fa-plus
                  //span.pl-2 {{ $t('settingsPage.configuration.addNewConfigurationGroup') }}

        v-col.pa-0.pr-6(cols="12" v-for="(i,idx) in configuration" :key="idx")
          v-card.pr-4.elevation-4(v-if="configuration" max-width="500px" height="300px" )
            v-card-title.pa-0
              v-row.ma-0
              v-col.pb-0(cols="6" v-if="configuration && i.title") {{'#' + (idx+1)}} {{i.title}}
              v-col.pb-0(cols="6" v-else) # {{idx}}
              v-col.text-end.pr-2.pb-0(cols="6")
                v-btn.text-end( small fab color="primary" @click="showEditConfigurationDialog(i)" )
                  v-icon(small) fal fa-pen
            v-card-text.pr-2

              v-list.pt-0.pb-0
                template()
                  v-row.justify-lg-space-around
                    v-col.pa-0(cols="12")
                      v-sheet
                        v-chip-group(show-arrows prev-icon="far fa-arrow-left" next-icon="far fa-arrow-right")
                          v-chip(v-for="(item, idx) in i.tags" :key="idx")

                            v-icon.mr-4e(left) {{item.iconClass}}
                            span {{item.title}}
                v-list(dense)
                  v-row.ma-0
                    v-checkbox.ma-0(
                      v-model="i.settings['configuration_group.is_mandatory']"
                      on-icon="fas fa-check-square"
                      off-icon="far fa-square"
                      readonly)
                    span.pt-2 {{ $t('settingsPage.configuration.allowedLabel') }}
                  v-row.ma-0
                    v-checkbox.ma-0(
                      v-model="i.settings['configuration_group.single_item']"
                      on-icon="fas fa-check-square"
                      off-icon="far fa-square"
                      readonly)
                    span.pt-2 {{ $t('settingsPage.configuration.singleFoodLabel') }}
                  v-row.ma-0
                    v-checkbox.ma-0(
                      v-model="i.settings['configuration_group.show_price']"
                      on-icon="fas fa-check-square"
                      off-icon="far fa-square"
                      readonly)
                    span.pt-2 {{ $t('settingsPage.configuration.showPriceLabel') }}

      v-skeleton-loader(v-if="fetchInProgress" type="list-item-three-line@3" width="100%")


</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {
  CREATE_NEW_CONFIGURATION_SETTINGS,
  DELETE_SELECTED_CONFIGURATION,
  FETCH_BUSINESS_DATA,
  FETCH_TAGS,
  GET_KEY,
  GET_SETTING_DATA,
  SAVE_NEW_SETTING,
  SAVE_SETTINGS, UPDATE_NEW_CONFIGURATION_SETTINGS
} from "@/store/action-types";
import Tag from "@/model/tennant/Tag";
import {Action} from "vuex-class";
import Configuration from "@/model/Configuration";
import AddNewConfigurationDialog from "@/components/settings/AddNewConfigurationDialog.vue";
import {NewSettingConfigurationPayload, SettingsPayload, UpdateSettingConfigurationPayload} from "@/types/payload";
import KeyList from "@/model/KeyList";
import SettingsKeyList from "@/model/SettingsKeyList";
import BusinessModel from "@/model/menu/BusinessModel";
import {usePiniaStore} from "@/store/piniaStore";


@Component({
  components: {
    AddNewConfigurationDialog
  }
})
export default class ConfigurationSettings extends Vue {

  @Action(FETCH_TAGS) fetchTagList!: ({ (): Promise<Tag[]> })
  @Action(SAVE_NEW_SETTING) onSaveNewSetting!: ({ (payload: SettingsPayload): Promise<void> })
  @Action(GET_KEY) fetchKey!: ({ (): Promise<any[]> })
  @Action(GET_SETTING_DATA) fetchSettingData!: ({ (): Promise<SettingsKeyList[]> })
  @Action(SAVE_SETTINGS) createSettings!: ({ (payload: any): Promise<void> })
  @Action(FETCH_BUSINESS_DATA) fetchBusinessData!: { (): Promise<BusinessModel[]> }
  @Action(DELETE_SELECTED_CONFIGURATION) deleteSelectedConfiguration!: ({ (payload: any): Promise<void> })
  @Action(CREATE_NEW_CONFIGURATION_SETTINGS) createNewConfigurationGroup!: ({ (payload: NewSettingConfigurationPayload): Promise<void> })
  @Action(UPDATE_NEW_CONFIGURATION_SETTINGS) updateConfigurationGroup!: ({ (payload: NewSettingConfigurationPayload): Promise<void> })

  private piniaStore = usePiniaStore()

  private snackBar: boolean = false
  private snackbarColor: string = ''
  private snackBarMessage: string | null = null
  private fetchInProgress: boolean = false
  private showAddNewConfigurationDialog:boolean = false
  private configuration: Configuration[] = []
  private tagList: Tag[] = []
  private selectedConfiguration: Configuration | null = null
  private key: string  = ''
  private keyList: KeyList[] | null = []
  private setttingsKeyList: SettingsKeyList[] | null = []
  private reserveAll: any = {
    id: '',
    key: 'tenant.automatically_reserve_all',
    value: false,
    name: '',
    type: ''
  }
  private orderTime: any = {
    id: '',
    key: 'boarder.force_pin_change',
    value: false,
    name: '',
    type: ''
  }
  private orderSingleGroup: any = {
    id: '',
    key: 'tenant.billing.supplier_name',
    value: false,
    name: '',
    type: ''
  }
  private business: BusinessModel[] | null = null
  private loading: boolean = false
  private isLoading: boolean = false
  private saveInProgress: boolean = false


  getData() {
    this.setttingsKeyList!.forEach((item: SettingsKeyList) => {
      const foundItem: KeyList | undefined = this.keyList!.find((i: KeyList) => item.name == i.key)
      if(foundItem) {
        if(item.name === 'tenant.automatically_reserve_all') {
          this.reserveAll = {
            id: foundItem.id,
            key: foundItem.key,
            value:  foundItem.value ? foundItem.value === 'true' ? true : false : item.defaultValue === 'true' ? true : false,
            name: item.name,
            type: item.type
          }
        }
      }
    })
  }

  get getFilteredTagList (): Tag[] {
    let usedTagIdList: any[] = []
    this.configuration.forEach((item: any) => {
      if(!this.selectedConfiguration || (this.selectedConfiguration && this.selectedConfiguration.id !== item.id)) {
          usedTagIdList.push(item.tagConfig)
      }
    })
    return this.tagList.filter((item: Tag) => !usedTagIdList.includes(item.id))
  }


  onAddNewConfigurationDialogClick(): void {
    this.selectedConfiguration = null
    this.showAddNewConfigurationDialog = true
  }

  onCloseDialogClick (): void{
    this.showAddNewConfigurationDialog = false
  }

  showEditConfigurationDialog (item: Configuration): void {
    this.selectedConfiguration = item
    this.showAddNewConfigurationDialog = true
  }

  async saveButtonClick (payload: NewSettingConfigurationPayload):Promise<void> {
    this.loading = true
    try {
      const response: any = await this.createNewConfigurationGroup(payload)
      this.snackBar = true
      this.snackbarColor = 'success'
      this.snackBarMessage = this.$t('sendEmailDialog.saved').toString()
    }catch (e) {
      this.snackBar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = this.$t('sendEmailDialog.valueNotSaved').toString()
    }finally {
      this.loading = false
      this.showAddNewConfigurationDialog = false

    }
    this.fetchConfiguration()
  }

  async updatedDataClick (payload: UpdateSettingConfigurationPayload):Promise<any> {
    this.loading = true
    try {
      const response: any = await this.updateConfigurationGroup(payload)
      this.snackBar = true
      this.snackbarColor = 'success'
      this.snackBarMessage = this.$t('sendEmailDialog.saved').toString()
    }catch (e) {
      this.snackBar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = this.$t('sendEmailDialog.valueNotSaved').toString()
    }finally {
      this.loading = false
      this.showAddNewConfigurationDialog = false
      this.selectedConfiguration = null

    }
    this.fetchConfiguration()
  }

  async onDeleteConfigurationClick (payload: any):Promise<void> {
    this.isLoading = true
    try {
      await this.deleteSelectedConfiguration(payload)
      this.snackBar = true
      this.snackbarColor = 'success'
      this.snackBarMessage = this.$t('sendEmailDialog.deleted').toString()

    }catch (e) {
      this.snackBar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = this.$t('sendEmailDialog.deleteDataError').toString()
    }finally {

      this.isLoading = false
      this.showAddNewConfigurationDialog = false
      this.fetchConfiguration()
    }
  }

  async fetchTagData ():Promise<void> {
    this.fetchInProgress = true
    try {
      this.tagList = await this.fetchTagList()
    }catch (e) {
      this.snackBar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = this.$t('errors.fetchDataError').toString()
    }finally {
      this.fetchInProgress = false
    }
  }

  async fetchSettingsKeys(): Promise<any> {
    this.fetchInProgress = true
    try {
      this.keyList = await this.fetchKey()
    } catch (e) {
      this.snackBar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = this.$t('errors.fetchDataError').toString()
    }finally {
      this.fetchInProgress = false
    }
  }

  async fetchSettingsData(): Promise<any> {
    this.fetchInProgress = true
    try {
      this.setttingsKeyList = await this.fetchSettingData()
    } catch (e) {

    }finally {
      this.fetchInProgress = false
    }
  }

  async fetchData(): Promise<void> {
    let promiseList: Promise<any[]>[] = []
    promiseList.push(this.fetchSettingsKeys())
    promiseList.push(this.fetchSettingsData())
    await Promise.all(promiseList)
    this.getData()
  }

  async saveSettings(payload: SettingsPayload): Promise<void> {
    this.saveInProgress = true
    try {
      await this.onSaveNewSetting(payload)
    }catch (e) {
      this.snackBar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = this.$t('sendEmailDialog.deleteDataError').toString()
    }finally {
      this.snackBar = true
      this.snackbarColor = 'success'
      this.snackBarMessage = this.$t('sendEmailDialog.dataSaved').toString()
      this.saveInProgress = false
    }
  }

  onSaveButtonClick (): void {
    if(this.reserveAll.id) {
      const payload1: SettingsPayload = {
        id: this.reserveAll.id,
        value: this.reserveAll.value
      }
      this.saveSettings(payload1)
    }else{
      const payload: any = {
        value: this.reserveAll.value,
        key: this.reserveAll.key
      }
      this.createNewSettings(payload)
    }

  }

  async createNewSettings(payload: any):Promise<void> {
    this.saveInProgress = true
    try {
      await this.createSettings(payload)
    } catch (e) {
      this.snackBar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = this.$t('sendEmailDialog.deleteDataError').toString()
    } finally {
      this.snackBar = true
      this.snackbarColor = 'success'
      this.snackBarMessage = this.$t('sendEmailDialog.dataSaved').toString()
      this.saveInProgress = false

    }
  }

  async fetchConfiguration():Promise<void>{
    try {
      this.configuration = await this.piniaStore.fetchConfigurationGroups()
    } catch (e) {
      this.snackBar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = this.$t('errors.fetchDataError').toString()
    }
  }

  async fetchBusiness(): Promise<void> {
    try {
      this.business = await this.fetchBusinessData()
      this.fetchConfiguration()
    } catch (e) {
      this.snackBar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = this.$t('errors.fetchDataError').toString()
    } finally {
    }
  }

   mounted () {
     this.fetchBusiness()
     this.fetchTagData()
     this.fetchData()
  }
}
</script>

<style lang="stylus" scoped>

.text-overflow-handle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}


</style>
